import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Fuel, Wheat, Route, X } from "lucide-react";

/** Floating action button + "quick log" fan-out menu.
 *  Mobile-first — fixed to the bottom-right, big thumb-friendly touch zones.
 *  Hidden on sm+ screens since the regular Add buttons live in the page header there.
 */
export default function QuickLogFab() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const items = [
    { label: "Expense", icon: Fuel, to: "/expenses?quick=1", testid: "fab-quick-expense", color: "bg-[#BC4727]" },
    { label: "Harvest", icon: Wheat, to: "/yields?quick=1", testid: "fab-quick-yield", color: "bg-[#1A4135]" },
    { label: "Mileage", icon: Route, to: "/mileage?quick=1", testid: "fab-quick-mileage", color: "bg-[#1F2A47]" },
  ];

  const go = (to) => {
    setOpen(false);
    navigate(to);
  };

  return (
    <div
      className="sm:hidden fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3 fab-container no-print"
      data-testid="quick-log-fab"
    >
      {open && (
        <>
          <div
            className="fixed inset-0 bg-black/20 backdrop-blur-[2px] -z-10"
            onClick={() => setOpen(false)}
            data-testid="fab-backdrop"
          />
          {items.map(({ label, icon: Icon, to, testid, color }) => (
            <button
              key={label}
              data-testid={testid}
              data-raw="true"
              onClick={() => go(to)}
              className={`${color} text-white px-4 py-2.5 pr-5 rounded-full flex items-center gap-2.5 shadow-xl shadow-black/20 text-sm font-semibold animate-in slide-in-from-bottom-2 fade-in duration-150`}
            >
              <Icon className="w-4 h-4" strokeWidth={2.2} />
              {label}
            </button>
          ))}
        </>
      )}
      <button
        data-testid="fab-toggle"
        data-raw="true"
        onClick={() => setOpen(!open)}
        className={`w-14 h-14 rounded-full flex items-center justify-center shadow-xl shadow-black/25 transition-transform ${
          open ? "bg-[#1F2A47] rotate-45" : "bg-[#1F2A47] hover:bg-[#15203A]"
        } text-white`}
        aria-label={open ? "Close quick log" : "Open quick log"}
      >
        {open ? <X className="w-6 h-6" strokeWidth={2.4} /> : <Plus className="w-6 h-6" strokeWidth={2.4} />}
      </button>
    </div>
  );
}
